import { Check, ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export const MultiSelect = ({ label, options, value, onChange, testid, renderLabel }) => {
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  const text = value.length === 0 ? "All" : value.length === 1 ? (renderLabel ? renderLabel(value[0]) : value[0]) : `${value.length} selected`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          data-testid={testid}
          className={`flex h-10 items-center gap-2 rounded-xl border px-3 text-sm transition-colors hover:border-slate-400 ${value.length ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700"}`}
        >
          <span className={value.length ? "text-slate-300" : "text-slate-400"}>{label}:</span>
          <span className="max-w-[140px] truncate font-medium">{text}</span>
          <ChevronDown className="h-4 w-4 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start">
        <Command>
          {options.length > 6 && <CommandInput placeholder={`Search ${label.toLowerCase()}...`} />}
          <CommandList>
            <CommandEmpty>Nothing found</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o} value={o} onSelect={() => toggle(o)} data-testid={`${testid}-option-${o}`}>
                  <span className={`mr-2 flex h-4 w-4 items-center justify-center rounded border ${value.includes(o) ? "border-slate-900 bg-slate-900 text-white" : "border-slate-300"}`}>
                    {value.includes(o) && <Check className="h-3 w-3" />}
                  </span>
                  {renderLabel ? renderLabel(o) : o}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
          {value.length > 0 && (
            <button className="w-full border-t px-3 py-2 text-left text-sm text-slate-500 hover:bg-slate-50" onClick={() => onChange([])} data-testid={`${testid}-clear`}>
              Clear selection
            </button>
          )}
        </Command>
      </PopoverContent>
    </Popover>
  );
};
